/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typography, Button, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import store from '../../../../redux/store';
import ValidateUser from '../../../../components/UserStatus';
import { setCompAllGroupAction } from '../../../../redux/actions/groups-listings';
import { deletePricingGroup } from '../../../../services/killshot';
import { refreshGroups, removeMarketplace } from '../../../../redux/actions/refresh-groups';
import { refreshInventory, refreshGroupedListings } from '../../../../redux/actions/refresh-groups-inventory';

const TEN = 10;
const FIFTY = 50;

const styles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
    height: '95%',
    overflowY: 'auto',
  },
  button: {
    marginTop: '10px',
  },
}));

const ModalContainer = styled.div`
  top: ${FIFTY}%;
  left: ${FIFTY}%;
  transform: translate(-${FIFTY}%, -${FIFTY}%);

  h2,
  h3 {
    margin-bottom: ${TEN}px;
  }
`;

const handleDeleteGroup = async (groupId, skipRefreshGroup) => {
  const skyboxId = store.getState().pricing.eventMeta.skybox_id;
  await deletePricingGroup(groupId);
  if (!skipRefreshGroup) {
    await store.dispatch(refreshGroups(skyboxId, true, groupId));
    store.dispatch(refreshGroupedListings(skyboxId));
    store.dispatch(refreshInventory(skyboxId));
  }
};

function GroupDeleteModal(props) {
  const { deleteGroupModalOpen, setDeleteGroupModalOpen } = props;
  const [isLoading, setIsLoading] = useState(false);
  const classes = styles();

  const handleDeleteGroupModalClose = () => {
    setDeleteGroupModalOpen(false);
  };

  const handleDeleteGroupModalSubmit = async () => {
    const { pricingGroup, pricingActions, setSelectedIndex, setSelectedPricingGroup } = props;
    store.dispatch(removeMarketplace(pricingGroup.id));
    pricingActions.setGroupEditingId(-1);
    setIsLoading(true);
    await handleDeleteGroup(pricingGroup.id);
    handleDeleteGroupModalClose();
    pricingActions.setGroupEditingId(-1);
    pricingActions.setGroup({
      splits: [],
    });
    setSelectedPricingGroup(null);
    setSelectedIndex(-1);
    store.dispatch(setCompAllGroupAction(false));
    store.dispatch(setCompAllGroupAction(false));
    pricingActions.setFocusedPricingGroupSection(null);
    pricingActions.setFormTNComparisonData([]);
    setIsLoading(false);
  };

  return (
    <Modal
      aria-labelledby="Delete Group"
      aria-describedby="Modal for Delete a Group"
      open={deleteGroupModalOpen}
      onClose={handleDeleteGroupModalClose}
      data-testid="delete-group-modal"
    >
      <ModalContainer className={classes.paper}>
        <ValidateUser />
        <Typography variant="h6" id="modal-title" gutterBottom>
          Are you sure you want to delete this group?
        </Typography>
        <form autoComplete="off" onSubmit={handleDeleteGroupModalSubmit}>
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDeleteGroupModalSubmit}
              fullWidth
              disabled={isLoading}
              className={classes.button}
              data-testid="confirm-delete-group-button"
            >
              ok
            </Button>
            <Button variant="contained" onClick={handleDeleteGroupModalClose} fullWidth className={classes.button}>
              No
            </Button>
          </div>
        </form>
      </ModalContainer>
    </Modal>
  );
}

GroupDeleteModal.propTypes = {
  deleteGroupModalOpen: PropTypes.bool.isRequired,
  setDeleteGroupModalOpen: PropTypes.func.isRequired,
  pricingActions: PropTypes.object.isRequired,
  pricingGroup: PropTypes.object.isRequired,
  setSelectedPricingGroup: PropTypes.func.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
};

export default GroupDeleteModal;
